import SwitchServer from 'container/SwitchServer';
import React from 'react';

export const FooterEnd = () => {
  return (
    <footer className='main-footer-end text-center'>
      <SwitchServer>
        {({ handleSwitchServer }) => (
          <strong onClick={handleSwitchServer}>
            &#9400; {new Date().getFullYear()} <span>Ringer Interactive. All rights reserved.</span>
          </strong>
        )}
      </SwitchServer>
    </footer>
  );
};

export default FooterEnd;
